module.exports = __webpack_public_path__ + "static/media/pipeinstall.95bd9194.svg";